import React, { useState } from 'react';
import ArtifactCard, { changeChip } from './artifacts/ArtifactCard';
import ArtifactTile from './artifacts/ArtifactTile';
import ArtifactDrawer from './artifacts/ArtifactDrawer';
import PartnerSuggestion from './PartnerSuggestion';

// Partner suggestions carry the owner's Introduce me / Not now, so they
// always show in full, with their buttons.
const ALWAYS_FULL = ['partner_recommendation'];

// Which result leads when a reply has several: the owner's question first.
const PRIORITY = ['am_i_ok', 'valuation_range', 'value_gap', 'readiness_scorecard', 'wealth_goal', 'deal_structure',
  'financing_scenario'];
const rank = (artifact) => {
  const i = PRIORITY.indexOf(artifact.kind);
  return i === -1 ? PRIORITY.length : i;
};

// New this turn (a first version) or changed (its headline figure moved).
const fresh = (artifact) => artifact.version === 1 || !!changeChip(artifact);

// The results one coach reply produced. A reply shows at most one result as
// its full card: the most important one that is new or changed. The others,
// and results the coach only brought up again, are glance tiles in a row;
// a tile opens the full card in a drawer, so the conversation doesn't move.
export default function MessageArtifacts({
  artifacts = [], partnerRecommendations = [], coachName, onAsk, onIntroducePartner, onPartnerNotNow, pending,
}) {
  const [open, setOpen] = useState(null); // { artifact, from }
  const foldable = artifacts.filter((a) => !ALWAYS_FULL.includes(a.kind)).sort((a, b) => rank(a) - rank(b));
  const lead = foldable.length === 1 ? foldable[0] : foldable.find(fresh);
  const tiles = foldable.filter((a) => a !== lead);

  const partnerFor = (artifact) => partnerRecommendations
    .filter((r) => String(r.artifact_id) === String(artifact.id))
    .map((r) => (
      <PartnerSuggestion
        key={r.need_key}
        recommendation={r}
        partnerName={artifact.data?.partner?.name}
        coachName={coachName}
        onIntroduce={onIntroducePartner}
        onNotNow={onPartnerNotNow}
        disabled={!!pending}
      />
    ));

  return (
    <>
      {lead && <ArtifactCard artifact={lead} coachName={coachName} onAsk={onAsk} />}
      {tiles.length > 0 && (
        <div
          className={`grid gap-2.5 grid-cols-2 ${tiles.length > 2 ? 'sm:grid-cols-3' : ''}`}
          data-testid="artifact-tiles"
        >
          {tiles.map((a) => (
            <ArtifactTile key={a.id} artifact={a} onOpen={(artifact, from) => setOpen({ artifact, from })} />
          ))}
        </div>
      )}
      {artifacts.filter((a) => ALWAYS_FULL.includes(a.kind)).map((a) => (
        <React.Fragment key={a.id}>
          <ArtifactCard artifact={a} coachName={coachName} onAsk={onAsk} />
          {partnerFor(a)}
        </React.Fragment>
      ))}
      <ArtifactDrawer
        artifact={open?.artifact}
        returnFocus={open?.from}
        coachName={coachName}
        onAsk={onAsk}
        onClose={() => setOpen(null)}
      />
    </>
  );
}
